import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { getRefundStatusMessage } from '../../refund-status/refund-status-mappings';
import { messages } from '../messages';

const RefundStatusTypeColumn = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { shipmentRefundStatusTypeId } = fulfillment;

  if (!shipmentRefundStatusTypeId) {
    return '';
  }

  return getRefundStatusMessage(shipmentRefundStatusTypeId);
};

RefundStatusTypeColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const RefundStatusType = {
  getMessageDescriptor: () => messages.refundStatus,
  id: 'refund-status',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <RefundStatusTypeColumn fulfillmentId={data.id} />;
  },
};
